export default {
    methods: {
        ToastSuccess:function(message=''){
            this.$buefy.toast.open({
                message: `${message} !`,
                type: 'is-success'
            })
    },
    ToastError:function(message=''){
        this.$buefy.toast.open({
            message: `${message} !`,
            type: 'is-danger'
        })
    }
    },
    computed:{
        searchStatus:{
  
          get:function(){
              return this.$store.getters.getSearchStatus
          },
          set:function(){
              this.$store.dispatch("ToggleSearchStatus")
          }
        }
      }
}

